import React from 'react';

export const FileUploadModalContext = React.createContext({});
